/* Sparbude: a world stays with collection, brand, search and product navigation. */
(() => {
  'use strict';
  const context = document.getElementById('sb-context');
  if (!context) return;
  const cfg = JSON.parse(context.textContent);
  const worlds = {'sb-pack-einzelartikel':'Einzelartikel','sb-pack-gebinde':'Gebinde','sb-pack-spar-sets':'Sparsets'};
  const known = Object.keys(worlds);
  const url = new URL(location.href);
  let saved = '';
  try { saved = sessionStorage.getItem('sparbude-world') || ''; } catch (_) {}
  let world = worlds[cfg.world] ? cfg.world : (worlds[saved] ? saved : '');
  const base = cfg.base.replace(/\/$/, '');
  const tagsInPath = decodeURIComponent(url.pathname).split('/').pop().split('+');
  const routeWorld = tagsInPath.find(tag => worlds[tag]);
  if (routeWorld) world = routeWorld;
  if (world) {
    try { sessionStorage.setItem('sparbude-world', world); } catch (_) {}
    document.documentElement.dataset.sbWorld = world;
  }
  // Older unscoped assortment links must not silently open a mixed catalogue.
  if (cfg.page === 'collection' && !routeWorld &&
      (url.pathname === base || url.pathname.startsWith(base + '/') || /\/collections\/all\/?$/.test(url.pathname))) {
    if (world) {
      const tags = url.pathname.startsWith(base + '/') ? tagsInPath.filter(t => t.startsWith('sb-') && !known.includes(t)) : [];
      url.pathname = base + '/' + [world, ...tags].join('+');
      location.replace(url.href); return;
    }
    location.replace(cfg.root); return;
  }
  const scopeLink = a => {
    if (!world || a.hasAttribute('data-sb-switch')) return;
    let target;
    try { target = new URL(a.getAttribute('href'), location.origin); } catch (_) { return; }
    if (target.origin !== location.origin) return;
    const targetTags = decodeURIComponent(target.pathname).split('/').pop().split('+');
    const explicitWorld = targetTags.find(tag => known.includes(tag));
    if (explicitWorld) return;
    if (a.hasAttribute('data-sb-home')) target.pathname = base + '/' + world;
    else if (a.hasAttribute('data-sb-scope') || target.pathname === base || target.pathname.startsWith(base + '/') || /\/collections\/all\/?$/.test(target.pathname)) {
      let tags = target.pathname.startsWith(base + '/') ? decodeURIComponent(target.pathname.slice(base.length + 1)).split('+') : [];
      tags = tags.filter(t => t && t.startsWith('sb-') && !known.includes(t));
      target.pathname = base + '/' + [world, ...tags].join('+');
    } else return;
    const next = target.pathname + target.search + target.hash;
    if (a.getAttribute('href') !== next) a.setAttribute('href', next);
  };
  const refresh = () => {
    document.querySelectorAll('a[href]').forEach(scopeLink);
    document.querySelectorAll('[data-sb-label]').forEach(el => el.textContent = world ? worlds[world] : 'Deine Einkaufswelt');
    document.querySelectorAll('[data-sb-current]').forEach(el => el.textContent = world ? 'Du bist bei ' + worlds[world] : 'Wähle deine Einkaufswelt');
    document.querySelectorAll('[data-sb-menu]').forEach(el => el.hidden = !world);
    document.querySelectorAll('[data-sb-search] input[name="q"]').forEach(el => el.placeholder = world ? worlds[world] + ' durchsuchen …' : 'Produkte suchen …');
  };
  refresh();
  document.addEventListener('click', e => {
    const switcher = e.target.closest('[data-sb-switch]');
    if (switcher) {
      const nextWorld = switcher.dataset.sbSwitch;
      if (worlds[nextWorld]) {
        world = nextWorld;
        try { sessionStorage.setItem('sparbude-world', nextWorld); } catch (_) {}
        document.documentElement.dataset.sbWorld = nextWorld;
        if (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
          e.preventDefault();
          e.stopPropagation();
          window.location.assign(switcher.href);
          return;
        }
      }
    }
    if (!e.target.closest('.sb-menu,.sb-world-switch')) document.querySelectorAll('.sb-menu details[open],.sb-world-switch[open]').forEach(d => d.open = false);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.sb-menu details[open],.sb-world-switch[open]').forEach(d => { d.open = false; d.querySelector('summary').focus(); });
  });
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!d.open || !d.matches('.sb-menu details,.sb-world-switch')) return;
    [...d.parentElement.children].filter(x => x !== d && x.tagName === 'DETAILS').forEach(x => x.open = false);
  }, true);
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-sb-search]');
    if (!form) return;
    e.preventDefault();
    const term = form.querySelector('[name="q"]').value.trim();
    if (!term) return;
    const target = new URL(cfg.search, location.origin);
    // Treat entered text as literal terms, so tag/operator input cannot leave the chosen world.
    const safeTerm = term.replace(/[():"\\]/g, ' ').replace(/\b(?:AND|OR|NOT)\b/g, ' ').trim();
    if (!safeTerm) return;
    target.searchParams.set('q', world ? '(' + safeTerm + ') AND tag:' + world : safeTerm);
    target.searchParams.set('type', 'product');
    location.assign(target.href);
  });
  // Facet filtering and load-more can insert collection links after page load.
  let queued = false;
  const observer = new MutationObserver(records => {
    if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1)) || queued) return;
    queued = true; requestAnimationFrame(() => { queued = false; refresh(); });
  });
  observer.observe(document.body, {childList:true, subtree:true});
})();
